module.exports = __webpack_public_path__ + "Storyboard2.png?e7d851f4123a8b7ca1caf6e6d4a85d8f";


//////////////////
// WEBPACK FOOTER
// ./static/Storyboard2.png
// module id = 346
// module chunks = 0